/**
 * @generated SignedSource<<7a03ad03c07e29e74d45aab8692242ff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CourseList_department$data = {
  readonly club: {
    readonly " $fragmentSpreads": FragmentRefs<"useGetClubStartOfWeekNumberPatron_club">;
  } | null | undefined;
  readonly courses: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly facility: {
          readonly name: string;
        };
        readonly id: string;
        readonly name: string;
        readonly " $fragmentSpreads": FragmentRefs<"CourseCard_course">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"useDepartmentMaxGolfCourseBookingWindow_department">;
  readonly " $fragmentType": "CourseList_department";
};
export type CourseList_department$key = {
  readonly " $data"?: CourseList_department$data;
  readonly " $fragmentSpreads": FragmentRefs<"CourseList_department">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CourseList_department",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Club",
      "kind": "LinkedField",
      "name": "club",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "useGetClubStartOfWeekNumberPatron_club"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useDepartmentMaxGolfCourseBookingWindow_department"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "archived",
          "value": false
        },
        {
          "kind": "Literal",
          "name": "facilityType",
          "value": "GOLF_COURSE"
        }
      ],
      "concreteType": "CourseConnection",
      "kind": "LinkedField",
      "name": "courses",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CourseEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Course",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Facility",
                  "kind": "LinkedField",
                  "name": "facility",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/)
                  ],
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "CourseCard_course"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "courses(archived:false,facilityType:\"GOLF_COURSE\")"
    }
  ],
  "type": "Department",
  "abstractKey": null
};
})();

(node as any).hash = "32d71a886718ce7d42605131f7a8bb7f";

export default node;
